import actions from '../../secrets-web/src/store/actions'
import authActions from './auth'

export default {
  ...actions,
  ...authActions
}